import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import cx from 'classnames';
import { components } from 'react-select';
import { isIncluded } from '../../utils/utils'; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export default function (props) {
  var _props$data = props.data,
      firstName = _props$data.firstName,
      lastName = _props$data.lastName,
      _props$data$email = _props$data.email,
      email = _props$data$email === void 0 ? '--' : _props$data$email;
  var name = "".concat(firstName, " ").concat(lastName);
  return /*#__PURE__*/React.createElement(components.Option, _extends({}, props, {
    className: cx(props.className, 'user-option')
  }), /*#__PURE__*/React.createElement("div", {
    className: "user-name",
    title: name
  }, name), /*#__PURE__*/React.createElement("div", {
    className: "user-email",
    title: email
  }, email));
} // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export var filterOption = function filterOption(candidate, input) {
  if (input) {
    var _candidate$data = candidate.data,
        email = _candidate$data.email,
        firstName = _candidate$data.firstName,
        lastName = _candidate$data.lastName;
    return email && isIncluded(email, input) || firstName && isIncluded(firstName, input) || lastName && isIncluded(lastName, input);
  }

  return true;
};